module.exports = __webpack_public_path__ + "img/battery-low.5dfdc05c.png";